export const guessFontSize = (
    text: String,
    height: number,
    width: number,
  ): number => {
      let trimmed = text.trim();
      for (let size = 1; size < 100; size++) {
        const fullLength = size * trimmed.length * 0.75; // font size is vertical px but letters are usually narrower
        const numLines = fullLength / width;
        if (numLines * size > height) {
            return size - 1;
        } 
      }
      // hopefully we don't get here
      return 50;
  }